import api from 'common/api';
import {
  SearchEntityGroupMasterRequest,
  DetailEntityGroupMasterRequest,
  UpdateEntityGroupMasterRequest,
  DeleteEntityGroupMasterRequest,
} from 'api-types/src/types/entity-group-master';

export const getAccountGrAPI = (params: SearchEntityGroupMasterRequest) => api.get('/entity-group-master/list', params);

export const getAccountGrDetailAPI = (params: DetailEntityGroupMasterRequest) =>
  api.get('/entity-group-master/detail', params);

export const addAccountGrAPI = (params: UpdateEntityGroupMasterRequest) => api.post('/entity-group-master', params);

export const updateAccountGrAPI = (params: UpdateEntityGroupMasterRequest) => api.put('/entity-group-master', params);

export const deleteAccountGrAPI = (params: DeleteEntityGroupMasterRequest) =>
  api.put('/entity-group-master/delete', params);

export const DOWNLOAD_EXCEL_ACCOUNT_GR_MAST = '/entity-group-master/list';
